export default Vue => {
    // 签章位置拖拽
    Vue.directive('drag', {
        inserted: function (el, binding) {
            let oDiv = el;
            oDiv.onmousedown = function (e) {
                let disX = e.clientX - oDiv.offsetLeft;
                let disY = e.clientY - oDiv.offsetTop;

                document.onmousemove = function (e) {
                    let left = e.clientX - disX;
                    let top = e.clientY - disY;
                    if (left < 0) {
                        left = 0;
                    }

                    let maxWidth = oDiv.parentNode.offsetWidth;
                    if (left + oDiv.offsetWidth > maxWidth) {
                        left = maxWidth - oDiv.offsetWidth;
                    }


                    if (top < 0) {
                        top = 0;
                    }

                    let maxHeight = oDiv.parentNode.offsetHeight;
                    if (top + oDiv.offsetHeight > maxHeight) {
                        top = maxHeight - oDiv.offsetHeight;
                    }

                    binding.value.rectangle.style.top =
                        (top / oDiv.parentNode.offsetHeight) * 100 + "%";
                    if (binding.value.rectangle.rectType !== 'ACROSS_PAGE') {
                        binding.value.rectangle.style.left =
                            (left / oDiv.parentNode.offsetWidth) * 100 + "%";
                    }
                    binding.value.rectangle.offsetX =
                        left / oDiv.parentNode.offsetWidth;
                    binding.value.rectangle.offsetY =
                        (oDiv.parentNode.offsetHeight -
                            oDiv.offsetHeight -
                            top) /
                        oDiv.parentNode.offsetHeight;
                };

                document.onmouseup = function () {
                    document.onmousemove = null;
                    document.onmouseup = null;
                    let top = parseFloat(binding.value.rectangle.style.top);
                    let height = parseInt(
                        binding.value.rectangle.style.height
                    );

                    let jumpNum;
                    let pageNum = 0;
                    let offset = 30;
                    let rectangle = binding.value.rectangle;
                    if (top > oDiv.parentNode.offsetHeight) {
                        pageNum =
                            (top - oDiv.parentNode.offsetHeight) /
                            oDiv.parentNode.offsetHeight;
                        jumpNum = Math.ceil(pageNum + rectangle.page);
                    } else if (top < 0) {
                        if (top + height / 2 > -offset / 2) {
                            binding.value.rectangle.style.top = "0px";
                            binding.value.rectangle.offsetY =
                                (oDiv.parentNode.offsetHeight -
                                    oDiv.offsetHeight -
                                    parseFloat(rectangle.style.top)) /
                                oDiv.parentNode.offsetHeight;

                            return;
                        }
                        if (top + height / 2 < -offset / 2) {
                            jumpNum = Math.floor(
                                top / oDiv.parentNode.offsetHeight +
                                rectangle.page
                            );
                        }
                    } else {
                        if (top + height > oDiv.parentNode.offsetHeight) {
                            if (
                                top + height / 2 <=
                                oDiv.parentNode.offsetHeight + offset / 2
                            ) {
                                rectangle.style.top =
                                    oDiv.parentNode.offsetHeight -
                                    height +
                                    "px";
                                rectangle.offsetY =
                                    (oDiv.parentNode.offsetHeight -
                                        oDiv.offsetHeight -
                                        parseFloat(rectangle.style.top)) /
                                    oDiv.parentNode.offsetHeight;

                                return;
                            }
                            if (
                                top + height / 2 >
                                oDiv.parentNode.offsetHeight + offset / 2
                            ) {
                                rectangle.style.top =
                                    oDiv.parentNode.offsetHeight +
                                    offset +
                                    "px";
                                rectangle.offsetY =
                                    (oDiv.parentNode.offsetHeight -
                                        oDiv.offsetHeight -
                                        parseFloat(rectangle.style.top)) /
                                    oDiv.parentNode.offsetHeight;

                                jumpNum = Math.floor(1 + rectangle.page);
                            }
                        } else {
                            return;
                        }
                    }

                    binding.value.rectangle.style.top =
                        parseFloat(rectangle.style.top) -
                        (jumpNum - rectangle.page) *
                        oDiv.parentNode.offsetHeight -
                        offset * (jumpNum - binding.value.rectangle.page) +
                        "px";
                    binding.value.rectangle.offsetY =
                        (oDiv.parentNode.offsetHeight -
                            oDiv.offsetHeight -
                            parseFloat(binding.value.rectangle.style.top)) /
                        oDiv.parentNode.offsetHeight;

                    if (
                        parseFloat(rectangle.style.top) < 0 ||
                        parseFloat(binding.value.rectangle.style.top) === 0
                    ) {
                        binding.value.rectangle.style.top = "0";
                        binding.value.rectangle.offsetY =
                            (oDiv.parentNode.offsetHeight -
                                oDiv.offsetHeight -
                                parseFloat(
                                    binding.value.rectangle.style.top
                                )) /
                            oDiv.parentNode.offsetHeight;
                    }
                    if (
                        parseFloat(rectangle.style.top) + height >
                        oDiv.parentNode.offsetHeight
                    ) {
                        binding.value.rectangle.style.top =
                            oDiv.parentNode.offsetHeight - height + "px";
                        binding.value.rectangle.offsetY =
                            (oDiv.parentNode.offsetHeight -
                                oDiv.offsetHeight -
                                parseFloat(
                                    binding.value.rectangle.style.top
                                )) /
                            oDiv.parentNode.offsetHeight;
                    }
                    binding.value.rectangle.page = jumpNum;
                };
            };
        }
    });

    // 自动聚焦
    Vue.directive('focus', {
        inserted: el => {
            let targetEl = el.childNodes;
            let autoFocusEl = ['INPUT', 'TEXTAREA', 'BUTTON'];
            if (targetEl.length) {
                for (let i = targetEl.length; i >= 0; i--) {
                    if (
                        targetEl[i] &&
                        autoFocusEl.includes(targetEl[i].tagName)
                    ) {
                        targetEl[i].focus();
                        break;
                    }
                }
            } else {
                el.focus();
            }
        }
    });

    Vue.directive('clickOutside', {
        // 初始化指令
        bind(el, binding) {
            function clickHandler(e) {
                // 这里判断点击的元素是否是本身，是本身，则返回
                if (el.contains(e.target)) {
                    return false;
                }
                // 判断指令中是否绑定了函数
                if (binding.expression) {
                    // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                    binding.value(e);
                }
            }
            // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
            el.__vueClickOutside__ = clickHandler;
            document.addEventListener('click', clickHandler);
        },
        update() { },
        unbind(el) {
            // 解除事件监听
            document.removeEventListener('click', el.__vueClickOutside__);
            delete el.__vueClickOutside__;
        },
    });
};
